import { render, staticRenderFns } from "./Ebox.vue?vue&type=template&id=6f4d29c4"
import script from "./Ebox.vue?vue&type=script&lang=js"
export * from "./Ebox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports